// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4737":"4157e60c","5511":"6a5b64ed"}[chunkId] + ".chunk.css";
};